<template>
  <nav class="list-layout" dir="rtl">
    <a
      v-for="(item, i) in displayedMedias"
      :key="i"
      :style="{
        background: getSocialColor(item.name) || hexToRgba(value.socialMediaIcons?.sectionColor?.backGround, 0.8),
        color: '#ffffff !important',
      }"
      class="social-list-item glass-effect elevation-2"
      @click="$emit('go-to-url', item.url, item.pattern)"
    >
      <div class="icon-circle">
        <svg-base :view-box="getViewBox(item.name)" style="display: block; margin: auto;">
            <component :is="item.svg" class="mt-0" />
        </svg-base>
            </div>

      <div class="content-text">
        <div class="title-text mb-2">{{ item.label }}</div>
        <div class="url-text" dir="ltr">{{ item.url }}</div>
      </div>

      <v-icon small color="white" class="arrow-icon">mdi-chevron-left</v-icon>
    </a>

    <!-- دکمه نمایش بیشتر / کمتر -->
    <div v-if="medias.length > initialLimit" class="toggle-container w-100 mt-4 mb-2">
      <div class="divider-line"></div>
      <button class="toggle-btn glass-effect" @click="isExpanded = !isExpanded">
        <v-icon small color="white" class="mr-1">
          {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
        <span>{{ isExpanded ? 'نمایش کمتر' : 'نمایش بیشتر' }}</span>
      </button>
      <div class="divider-line"></div>
    </div>
  </nav>
</template>

<script>
import SvgBase from "@/view/content/svgLoader/svgBase";
const viewBoxConfig = {
  // شبکه‌های اجتماعی ایرانی
  aparat: 40,
  gap: 40,

  // شبکه‌های اجتماعی خارجی
  linkedin_company: '-10 -10 60 60',
  github: 32,
  threads: 42,
  skype: 40,
  youtube: 40,
  wechat: 40,
  viber: 40,

  // سایت‌های آگهی و فروشگاهی
  divar: '0 0 40 24.33',
  sheypoor: 40,
  digikala: '0.00 0.00 1080.00 1080.00',
  basalam: '0 0 128 208',
  snappshop: '0 0 69 40',    
  technolife: '0 0 112 42',
  torob: '0.00 0.00 130.00 130.00',        
  emalls: '0.00 0.00 300.00 78.00',

  // استورها
  cafebazaar: '0.00 0.00 303.00 132.00',
  googleplay: '0 -4.447 361.403 408.86699999999996',
  samsung: '0 0 230 230',
  apple: '0 0 512 512',
}

export default {
  name: "SocialList",
  components: { SvgBase },
  props: {
    medias: { type: Array, required: true },
    value: { type: Object, required: true },
    getSocialColor: { type: Function, required: true },
    hexToRgba: { type: Function, required: true }
  },
  methods:{
    getViewBox(name) {
      return viewBoxConfig[name] || '0 0 50 50';
    },
  },
  data() {
    return {
      isExpanded: false,
      initialLimit: 4 
    };
  },
  computed: {
    displayedMedias() {
      if (this.isExpanded) {
        return this.medias;
      }
      return this.medias.slice(0, this.initialLimit);
    }
  }
};
</script>

<style lang="scss" scoped>
.list-layout {
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  margin: 0;
  width: 90%;
  box-sizing: border-box;
  align-items: center;

  .social-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 8px);
  box-sizing: border-box;
  height: 64px;
  margin: 8px 0;
  padding: 0 16px;
  border-radius: 35px;
  position: relative;
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
}

  .toggle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 0 8px;

    .divider-line {
      flex: 1;
      height: 1px;
      background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
    }

    .toggle-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 6px 16px;
      border-radius: 20px;
      font-size: 0.8rem;
      font-weight: 500;
      color: #ffffff;
      background: rgba(255, 255, 255, 0.15);
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      &:hover {
        background: rgba(255, 255, 255, 0.25);
        transform: translateY(-2px);
      }
      
      span {
        margin-top: 2px; 
      }
    }
  }
}

.glass-effect {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}
.icon-circle ::v-deep svg {
  width: 45px;
  height: 45px;
  display: block;
  margin: auto;
}

.icon-circle ::v-deep svg * {
  max-width: 100%;
  max-height: 100%;
}
.content-text {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 12px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;

  .title-text {
    width: 80%;
    font-size: 0.95rem;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.2;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .url-text {
    width: 80%;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.2;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    direction: ltr;
    text-align: right;
  }
}

</style>
